<template>
  <b-form-row>
    <b-modal size="xl" button-size="sm" hide-footer v-model="showModal" :title="prefix + title" @hidden="cancelar">

      <b-card no-body>
        <b-card-body>
          <b-card bg-variant="light">
            <b-form-row @keyup.enter="load" @keyup.tab="fillWithZerosOnTab">
              <lg-form-input sm="2" invalidFeedback="Informe o início do tombamento" description=""
                v-model="form.numTombamento" label="Tombamento:" maxlength="8" />

              <lg-form-input sm="2" invalidFeedback="Informe o fim do tombamento" description=""
                v-model="form.numTombamentoAte" label="Até:" maxlength="8" />

              <lg-form-date sm="2" invalidFeedback="A data de deve ser informada!" description="" v-model="form.dataDe"
                label="Entrada:" />
              <lg-form-date sm="2" invalidFeedback="A data limite deve ser informada!" description=""
                v-model="form.dataAte" label="Até:" />

              <b-col lg="4" sm="12" class="text-left">
                <LgFinderPageTipoEstadoConservacao id="finderTipoEstadoConservacao" @input="selectTipoEstado"
                  v-model="form.tipoestadoconservacao" :prefix="[prefix + title]" :isModal="true">
                </LgFinderPageTipoEstadoConservacao>
              </b-col>

              <lg-form-input invalidFeedback="Informe um tombamento válido" description="" sm="4"
                v-model="form.numTombamentoSamp" label="Tombamento SAMP:" maxlength="10" />

              <b-col lg="4" sm="12" class="text-left">
                <LgFinderPageEmpenho @input="selectEmpenho" v-model="form.empenho" :value="form.empenho"
                  label="Empenho:" id="finderEmpenho" invalidFeedback="A empresa deve ser informada!" description=""
                  :prefix="[prefix + title]" />
              </b-col>

              <lg-form-input sm="4" lg="4" invalidFeedback="O número processo deve ser informado!" description=""
                v-model="form.nroProcesso" label="Nº Processo:" />

              <b-col lg="4" sm="12" class="text-left">

                <LgFinderPageUnidadeAdministrativa id="finderDepartamentoIBP" v-model="form.departamento"
                  @onselect="departamentoSelect"> </LgFinderPageUnidadeAdministrativa>
              </b-col>

              <b-col lg="4" sm="12" class="text-left">
                <LgFinderPageModelo v-model="form.modelo" :prefix="[prefix + title]" @input="selectModelo"
                  id="finderPageModelo" label="Modelo:" invalidFeedback="Modelo deve ser informado!" />
              </b-col>

              <lg-form-input sm="4" invalidFeedback="Informe um número de contrato válido!" description=""
                v-model="form.nroContrato" label="Nº Contrato:" />

              <b-col lg="4" sm="12" class="text-left">
                <lg-finder-page-local-armazenamento id="finderPageArmazenamento" @close="localArmazenamentoSelect"
                  v-model="form.localArmazenamento" :prefix="prefix + title + ' > '" />
              </b-col>

              <b-col lg="4" sm="12" class="text-left">
                <LgFinderPageMarca v-model="form.marca" @input="marcaSelect" :prefix="[prefix + title]"
                  id="finderPageMarca" label="Marca:" invalidFeedback="Marca deve ser informada!" cols="12" />

              </b-col>
              <lg-form-input sm="4" invalidFeedback="Informe uma descrição válida" description=""
                v-model="form.descricaoProduto" label="Descrição:" />

              <b-col lg="4" sm="12" class="text-left">
                <LgFinderPageNatureza v-model="form.natureza" @input="naturezaSelect" :prefix="[prefix + title]"
                  id="finderPageNatureza" label="Natureza:" invalidFeedback="Marca deve ser informada!" cols="12"
                  fromItemBemPermanenteList />
              </b-col>

              <b-col lg="4" sm="12" class="text-left">
                <LgFinderPagePessoa v-model="form.responsavel" @onselect="responsavelSelect"
                  @onClear="responsavelSelect" :prefix="prefix + title + ' > '" id="finderPagePessoa"
                  label="Utilizado por:" cols="12" />

              </b-col>

              <b-col lg="4" sm="12" class="text-left">
                <b-col cols="12" class="text-left">
                  <b-form-checkbox v-model="form.descricaoExata" :value="true" :unchecked-value="false">
                    Descrição exata
                  </b-form-checkbox>
                </b-col>

              </b-col>

              <b-col lg="4" sm="12" class="text-left">
                <LgFinderPageStatus v-model="form.status" id="finderPageStatus" @input="selectStatus"
                  :prefix=[prefix,title] label="Status:" cols="12" />
              </b-col>


              <lg-form-const-select sm="2" label="Situação:" v-model="form.situacao"
                :options="form.optionsFilterSituacao" @change="load" />

              <lg-form-const-select label="Relacionado:" v-model="form.relacionado" sm="2"
                :options="form.optionsFilterRelacionado" @change="load" />

              <lg-form-input sm="4" invalidFeedback="O número processo deve ser informado!" description=""
                v-model="form.nroSerie" label="Nº Série:" />
              <lg-form-input sm="4" invalidFeedback="O número processo deve ser informado!" description=""
                v-model="form.numero" label="Número:" />

              <b-col lg="4" sm="12" class="text-left">
                <LgFinderPageSubgrupoProduto @onSelect="subgrupoSelect" v-model="form.subgrupo"
                  :prefix="prefix + title + ' > '" id="finderPageSubgrupo" label="SubGrupo:"
                  invalidFeedback="Marca deve ser informada!" cols="12" fromItemBemPermanenteList />
              </b-col>

              <b-col lg="4" sm="12" class="text-left">
                <LgFinderPageClasse @onselect="classeSelect" v-model="form.classe" :prefix="prefix + title + ' > '"
                  id="finderClasse" label="Classe:" invalidFeedback="Modelo deve ser informado!" />
              </b-col>


            </b-form-row>

            <b-form-row>
              <b-col cols="12" class="text-right">
                <b-button id="LimparIbp" class="mr-2 my-2" size="sm" style="height: 20px" pill variant="primary"
                  @click="clearForm">
                  <div class="btn-size-alinhamento">
                    <b-icon icon="eraser" />
                  </div>
                  <b-tooltip target="LimparIbp" title="Limpar" triggers="hover"></b-tooltip>
                </b-button>

                <b-button id="pesquisaIbp" class="mr-2 my-2" size="sm" style="height: 20px" pill variant="primary"
                  @click="load()">
                  <div class="btn-size-alinhamento">
                    <b-icon icon="search" />
                  </div>
                  <b-tooltip target="pesquisaIbp" title="Localizar" triggers="hover"></b-tooltip>
                </b-button>
              </b-col>
            </b-form-row>
          </b-card>

          <b-card bg-variant="light">
            <b-table id="tabelaItem" responsive class="mt-2" small :busy="this.busy" :items="this.records"
              :fields="this.tableFields" :hover="true" @row-dblclicked="itemBemPermanenteSelect"
              @row-cliked="itemBemPermanenteSelect" show-empty>
              <template #table-busy>
                <div class="text-center text-primary my-2">
                  <b-spinner class="align-middle"></b-spinner>
                </div>
              </template>
              <template #empty>
                <p>Nenhum resultado encontrado</p>
              </template>
              <template v-slot:cell(action)="row">
                <b-button id="visualizarHCP" size="sm"  pill variant="primary"
                  @click="visualizarConsulta(row.item)">
                    <b-icon icon="eye" />
                  <b-tooltip target="visualizarHCP" title="Visualizar..." triggers="hover"></b-tooltip>
                </b-button>
              </template>

            </b-table>
            <b-row style="margin-top: 12px" v-if="records && records.length > 0">
              <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">
                <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">Página {{ page }} de {{
                  totalPage }} -
                  {{ total }} registros</b-col>
                <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">Mostrando:&nbsp;
                  <b-form-select size="sm" v-model="perPage" @change="() => this.load()" :options="perPageOptions">
                  </b-form-select>
                </b-col>
              </b-col>
              <b-col cols="6">
                <div class="d-flex justify-content-end align-items-end">
                  <b-pagination style="margin-bottom: 10px; margin-top: 10px" v-model="page" :per-page="perPage"
                    :total-rows="total"></b-pagination>
                </div>
              </b-col>
            </b-row>
          </b-card>
        </b-card-body>
        <ModalItemBemPermanenteView :prefix="prefix + title + ' > '" :title="'Visualização'" v-if="mostrarConsultaIBP" :id="idItemBemPermanente"
          @fecharModal="fecharModal" />

      </b-card>
    </b-modal>
  </b-form-row>
</template>
<script>
import LgFinderPageClasse from '@/components/Finders/LgFinderPageClasse.vue'
import LgFinderPageEmpenho from "@/components/Finders/LgFinderPageEmpenho.vue"
import LgFinderPageLocalArmazenamento from "@/components/Finders/LgFinderPageLocalArmazenamento.vue"
import LgFinderPageMarca from "@/components/Finders/LgFinderPageMarca.vue"
import LgFinderPageModelo from "@/components/Finders/LgFinderPageModelo.vue"
import LgFinderPageNatureza from "@/components/Finders/LgFinderPageNatureza.vue"
import LgFinderPagePessoa from "@/components/Finders/LgFinderPagePessoa.vue"
import LgFinderPageStatus from '@/components/Finders/LgFinderPageStatus.vue'
import LgFinderPageSubgrupoProduto from '@/components/Finders/LgFinderPageSubgrupoProduto.vue'
import LgFinderPageTipoEstadoConservacao from "@/components/Finders/LgFinderPageTipoEstadoConservacao.vue"
import LgFinderPageUnidadeAdministrativa from '@/components/Finders/LgFinderPageUnidadeAdministrativa.vue'
import ResourceService from "@/core/api/ResourceService"
import LgFormConstSelect from "@/core/components/Form/LgFormConstSelect.vue"
import LgFormDate from "@/core/components/Form/LgFormDate.vue"
import LgFormInput from "@/core/components/Form/LgFormInput.vue"
import ConfirmMixin from "@/core/mixins/confirm"
import { FormResourceMixin, ListResourceMixin } from "@/core/mixins/resource"
import moment from "moment"
import ModalItemBemPermanenteView from '@/core/components/Modals/ModalItemBemPermanenteView.vue'

export default {
  name: "HistoricoCargaPatrimonialItensList",
  components: {
    LgFinderPageUnidadeAdministrativa,
    ModalItemBemPermanenteView,
    LgFormInput,
    LgFormDate,
    LgFinderPagePessoa,
    LgFormConstSelect,
    LgFinderPageLocalArmazenamento,
    LgFinderPageTipoEstadoConservacao,
    LgFinderPageEmpenho,
    LgFinderPageMarca,
    LgFinderPageModelo,
    LgFinderPageNatureza,
    LgFinderPageClasse,
    LgFinderPageSubgrupoProduto,
    LgFinderPageStatus

  },
  mixins: [ConfirmMixin, ListResourceMixin, FormResourceMixin],

  props: {
    id: Number,
    mostrarSelecao: {
      type: Boolean,
      default: false
    },
    prefix: {
      tipe: String,
      default: "",
    },
  },
  created() {
    const brand = JSON.parse(localStorage.getItem("context"))
    this.form.departamento = brand.departamento
    this.params.departamentoId = brand.departamento.id
  },
  data() {
    return {
      showModal: true,
      selecionarTodos: false,
      mostrarConsultaIBP: false,

      params: {},
      perPage: 10,
      perPageOptions: [10, 25, 50, 100],
      filtro: "",
      title: "Item Bem Permanente do Histórico",
      form: {
        pessoa: {},
        pessoas: [],
        produto: {},
        produtos: [],
        id: "",
        s_numTombAntigo: "",
        numeroProcesso: "",
        descricaoProduto: "",
        nroContrato: "",
        localArmazenamento: {},
        tipoestadoconservacao: {},
        dataDe: "",
        dataAte: "",
        notaFiscal: "",
        status: {},
        responsavel: {},
        numTombamento: "",
        numTombamentoSamp: "",
        departamento: {},
        natureza: {},
        numero: "",
        classe: {},
        subgrupo: {},
        empenho: {},
        modelo: {},
        marca: {},
        descricaoExata: false,

        situacao: "1",
        optionsFilterSituacao: [
          { key: "filterSituacao", text: "Todos", value: undefined },
          { key: "filterSituacao", text: "Ativo", value: "1" },
          { key: "filterSituacao", text: "Inativo", value: "0" },
        ],

        relacionado: null,
        optionsFilterRelacionado: [
          { key: "filterSituacao", text: "Todos", value: undefined },
          { key: "filterSituacao", text: "Sim", value: "1" },
          { key: "filterSituacao", text: "Não", value: "0" },
        ],
      },
    }
  },

  beforeMount() {
    this.$service = new ResourceService(`/api/historicocargapatrimonial`)
    this.$statusService = new ResourceService(`/api/status/tipo/6`)
    this.$serviceStatus = new ResourceService(`/api/status`)
  },
  async mounted() {
    this.load()
  },
  watch: {
    page() {
      this.load()
    },

    "form.situacao"() {
      this.load()
    },
    "form.numTombamento"() {
      if (
        this.form.numTombamento !== null &&
        this.form.numTombamento !== undefined &&
        this.form.numTombamento !== ""
      ) {
        setTimeout(() => {
          this.form.numTombamento = this.form.numTombamento
            .toString()
            .padStart(8, "0")
        }, 2500)
      }
    },
    "form.numTombamentoAte"() {
      if (
        this.form.numTombamentoAte !== null &&
        this.form.numTombamentoAte !== undefined &&
        this.form.numTombamentoAte !== ""
      ) {
        setTimeout(() => {
          this.form.numTombamentoAte = this.form.numTombamentoAte
            .toString()
            .padStart(8, "0")
        }, 2500)
      }
    },
    "form.numTombamentoSamp"() {
      if (
        this.form.numTombamentoSamp !== null &&
        this.form.numTombamentoSamp !== undefined &&
        this.form.numTombamentoSamp !== ""
      ) {
        setTimeout(() => {
          this.form.numTombamentoSamp = this.form.numTombamentoSamp
            .toString()
            .padStart(10, "0")
        }, 2500)
      }
    },
  },
  computed: {
    tableFields() {
      return [
        {
          key: "itemBemPermanente.numTombamento",
          label: "Tombamento",
          thStyle: "font-size: 14px; font-weight: 400;",
          tdStyle: "font-size: 13px",
        },
        {
          key: "itemBemPermanente.s_numTombAntigo",
          label: "Tombamento SAMP",
          thStyle: "font-size: 14px; font-weight: 400;",
          tdStyle: "font-size: 13px",
        },
        {
          key: "itemBemPermanente.itemRegEntrada.produto.numero",
          label: "Número",
          thStyle: "font-size: 14px; font-weight: 400;",
          tdStyle: "font-size: 13px",
          tdClass: "",
        },
        {
          key: "itemBemPermanente.itemRegEntrada.produto.descricaoResumida",
          label: "Descrição",
          thStyle: "font-size: 14px; font-weight: 400; max-width: 100px !important",
          tdStyle: "font-size: 13px; max-width: 100px !important",
        },
        {
          key: "itemBemPermanente.relacionado",
          label: "BR",
          thStyle: "font-size: 14px; font-weight: 400;",
          tdStyle: "font-size: 13px",
        },
        {
          key: "itemBemPermanente.dataEntrada",
          label: "Data Aquisição",
          formatter: (data) => moment(String(data)).format("DD/MM/YYYY"),
          thStyle: "font-size: 14px; font-weight: 400;",
          tdStyle: "font-size: 13px",
        },
        {
          key: "itemBemPermanente.valorOriginal",
          label: "Valor Aquisição (R$)",
          thStyle: "font-size: 14px; font-weight: 400;",
          tdStyle: "font-size: 13px",
          formatter: (value) => {
            return value.toLocaleString("pt-BR", {
              style: "decimal",
              currency: "BRL",
              minimumFractionDigits: 2,
            })
          },
        },
        {
          key: "action",
          label: " ",
          tdClass: "w-1",
          thStyle: "font-size: 14px; font-weight: 400;",
          tdStyle: "font-size: 13px",
        },
      ]
    },
  },
  methods: {
    cancelar() {
      this.$emit("close");
    },
    async load() {
      this.busy = true
      this.params = {};

      this.params.carga = this.id;
      this.params.numTombamentoDe = null
      this.params.numTombamentoAte = null
      this.params.numTombamento = null

      if (this.form.responsavel && this.form.responsavel.id) {
        this.params.utilizadoPor = this.form.responsavel.id;
      }

      if (
        this.form.numTombamento != undefined &&
        this.form.numTombamento != ""
      ) {
        if (
          this.form.numTombamentoAte != undefined &&
          this.form.numTombamentoAte != ""
        ) {
          this.params.numTombamentoDe = this.form.numTombamento
          this.params.numTombamentoAte = this.form.numTombamentoAte
        } else {
          this.params.numTombamento = this.form.numTombamento
        }
      }

      if (this.form.natureza && this.form.natureza.id)
        this.params.naturezaId = this.form.natureza.id;

      this.params.numTombamentoSAMP = null
      if (this.form.numTombamentoSamp) {
        this.params.numTombamentoSAMP = this.form.numTombamentoSamp
      }

      this.params.dataInicio = null
      this.params.dataFim = null
      if (this.form.dataDe && this.form.dataAte) {
        this.params.dataInicio = moment(String(this.form.dataDe)).format(
          "DD/MM/YYYY"
        )
        this.params.dataFim = moment(String(this.form.dataAte)).format(
          "DD/MM/YYYY"
        )
      }

      this.params.descricao = null
      if (this.form.descricaoProduto) {
        this.params.descricao = this.form.descricaoProduto
      }

      this.params.descricaoExata = this.form.descricaoExata

      this.params.produtoId = null
      if (this.form.produto && Object.keys(this.form.produto).length > 0) {
        this.params.produtoId = this.form.produto
      }

      this.params.numProcesso = null
      if (this.form.numeroProcesso) {
        this.params.numProcesso = this.form.numeroProcesso
      }

      this.params.numContrato = null
      if (this.form.nroContrato) {
        this.params.numContrato = this.form.nroContrato
      }

      this.params.statusId = null
      if (this.form.status && this.form.status.id) {
        this.params.statusId = this.form.status.id
      }

      this.params.numSerie = null
      if (this.form.nroSerie) {
        this.params.numSerie = this.form.nroSerie
      }

      this.params.situacao = null
      if (this.form.situacao) {
        this.params.situacao = this.form.situacao
      }

      this.params.classeId = null
      if (this.form.classe && this.form.classe.id) {
        this.params.classeId = this.form.classe.id
      }

      this.params.subGrupoProdutoId = null
      if (this.form.subgrupo && this.form.subgrupo.id) {
        this.params.subGrupoProdutoId = this.form.subgrupo.id
      }

      this.params.localArmazenamentoId = null
      if (this.form.localArmazenamento && this.form.localArmazenamento.id) {
        this.params.localArmazenamentoId = this.form.localArmazenamento.id
      }

      this.params.numeroEmpenho = null
      if (this.form.empenho && this.form.empenho.id) {
        this.params.numeroEmpenho = this.form.empenho.id
      }

      this.params.marcaId = null
      if (this.form.marca && this.form.marca.id) {
        this.params.marcaId = this.form.marca.id
      }

      this.params.modeloId = null
      if (this.form.modelo && this.form.modelo.id) {
        this.params.modeloId = this.form.modelo.id
      }

      this.params.tipoEstadoConservacaoId = null
      if (this.form.tipoestadoconservacao && this.form.tipoestadoconservacao.id) {
        this.params.tipoEstadoConservacaoId = this.form.tipoestadoconservacao.id
      }

      this.params.numeroProduto = null
      if (this.form.numero) {
        this.params.numeroProduto = this.form.numero
      }

      this.busy = true;
      await this.$loadResource({
        size: this.perPage,
        page: this.page,
        params: this.params,
      })
      this.busy = false
    },
    async handleSelectUnidadeAdministrativa(unidadeAdministrativa) {
      this.form.unidadeAdministrativa = unidadeAdministrativa
    },
    async buscarProduto() {
      this.$service = new ResourceService(`/api/produto`)
      return await this.$serviceProduto.findAll({})
    },
    async showPessoa() {
      await this.$refs.finderPessoa.show()
    },
    async handleSelectProduto(item) {
      this.$set(this.form, "produto", item)
    },
    async handleProdutoSelect(produto) {
      this.form.produto = produto
    },
    async showProduto() {
      await this.$refs.finderProduto.show()
    },
    async itemBemPermanenteSelect(item) {


      if (item.bloqueado && !this.podePegarBloqueado) {
        this.$notify({
          type: "danger",
          message: "Item Bem Permanente Bloqueado",
        });

      }
      else
        this.$emit("onDblClickItemBemPermanente", item);

    },
    clearForm() {
      this.form.numTombamento = ""
      this.form.numTombamentoAte = ""
      this.form.numTombamentoSamp = ""
      this.form.numeroSerie = ""
      this.form.situacao = "1"
      this.form.empenho = {}
      this.form.nroProcesso = ""
      this.form.modelo = {}
      this.form.marca = {}
      this.form.nroSerie = ""
      this.form.numero = ""
      this.form.nroContrato = ""
      this.form.natureza = {}
      this.form.responsavel = {}
      this.form.classe = {}
      this.form.subgrupo = {}
      this.form.descricaoExata = false;
      this.form.localArmazenamento = {}
      this.form.tipoestadoconservacao = {}
      this.form.descricaoProduto = ""
      this.form.relacionado = null
      this.params = {}
      const brand = JSON.parse(localStorage.getItem("context"))
      this.form.departamento = brand.departamento
      this.params.departamentoId = brand.departamento.id
      this.load()
    },
    fillWithZerosOnTab(event) {
      if (event.key === "Tab") {
        if (
          this.form.numTombamento !== null &&
          this.form.numTombamento !== undefined &&
          this.form.numTombamento !== ""
        ) {
          this.form.numTombamento = this.form.numTombamento
            .toString()
            .padStart(8, "0")
        }
        if (
          this.form.numTombamentoAte !== null &&
          this.form.numTombamentoAte !== undefined &&
          this.form.numTombamentoAte !== ""
        ) {
          this.form.numTombamentoAte = this.form.numTombamentoAte
            .toString()
            .padStart(8, "0")
        }
        if (
          this.form.numTombamentoSamp !== null &&
          this.form.numTombamentoSamp !== undefined &&
          this.form.numTombamentoSamp !== ""
        ) {
          this.form.numTombamentoSamp = this.form.numTombamentoSamp
            .toString()
            .padStart(10, "0")
        }
      }
    },
    fecharModal() {
      this.mostrarConsultaIBP = false;


    },
    visualizarConsulta(item) {
      this.idItemBemPermanente = item.itemBemPermanente.id
      this.mostrarConsultaIBP = true
    },
    visualizarModalAgregacao(item) {
      this.IbpSelecionado = item
      this.mostrarModalAgregacao = true
    },
    visualizarModal(item) {
      this.idItemBemPermanente = item.id
      this.mostrarModal = true

    },
    visualizarModalReavaliacao(item) {
      this.IbpSelecionado = item
      this.mostrarModalReavaliacao = true
    },
    visualizarModalDocumentoIBP(item) {
      this.idItemBemPermanente = item.id
      this.mostrarModalDocumentoIBP = true
    },
    visualizarModalHistoricoSenado(item) {
      this.idItemBemPermanente = item.id
      this.mostrarModalHistoricoSenado = true

    },
    visualizarmostrarModalFotoIBP(item) {
      this.idItemBemPermanente = item.id
      this.mostrarModalFotoIBP = true
    },
    visualizarModalFotoProdutoIBP(item) {
      this.idItemBemPermanente = item.itemRegEntrada.produto.id;
      this.mostrarModalFotoProdutoIBP = true
    },

    visualizarModalEstadoConservacao(item) {
      this.idItemBemPermanente = item.id
      this.mostrarModalEstadoConservacao = true

    },
    visualizarModalApoliceSeguroIBP(item) {
      this.idItemBemPermanente = item.id
      this.mostrarModalApoliceSeguroIBP = true
    },
    visualizarModalRelatorioDepreciacao(item) {
      this.idItemBemPermanente = item.id
      this.mostrarModalRelatorioDepreciacao = true

    },
    selectTipoEstado(item) {
      this.form.tipoestadoconservacao = item;
      this.load();
    },
    selectEmpenho(item) {
      this.form.empenho = item;
      this.load();
    },
    selectModelo(item) {
      this.form.modelo = item;
      this.load();
    },
    localArmazenamentoSelect(item) {
      this.form.localArmazenamento = item;
      this.load();
    },
    marcaSelect(item) {
      this.form.marca = item;
      this.load();
    },
    naturezaSelect(item) {
      this.form.natureza = item;
      this.load();
    },
    selectStatus(item) {
      this.form.status = item;
      this.load();
    },
    responsavelSelect(item) {
      this.form.responsavel = item;
      this.load();
    },
    departamentoSelect(item) {
      this.form.departamento = item;
      this.load();
    },
    subgrupoSelect(item) {
      this.form.subgrupo = item;
      this.load();
    },
    classeSelect(item) {
      this.form.classe = item;
      this.load();
    }
  },
}
</script>
